import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logoEnv from '../assets/logo-envvv.png';
import logoNovi from '../assets/logo-noviii.png';
import '../styles/terms.css';

const SECTION_HEADING = /^\d+\.\s+[A-ZÁÉÍÓÚÜÑ][A-ZÁÉÍÓÚÜÑ\s,()/-]+$/;
const STEP_HEADING = /^\d+\.\s+(Comprar|Conservar|Completar|Aceptar)\b/;

function renderLine(line, index) {
  const text = line.trim();
  if (!text) return null;
  if (index === 0) return <h1 key={index}>{text}</h1>;
  if (index === 1) return <p className="terms-subtitle" key={index}>{text}</p>;
  if (SECTION_HEADING.test(text)) return <h2 key={index}>{text}</h2>;
  if (STEP_HEADING.test(text) || text.endsWith(':')) return <h3 key={index}>{text}</h3>;
  return <p key={index}>{text}</p>;
}

export default function Terms() {
  const [content, setContent] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'Bases, términos y condiciones | Novicompu';
    fetch('/terminos.md', { cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error('No fue posible cargar el documento.');
        return response.text();
      })
      .then(setContent)
      .catch((requestError) => setError(requestError.message));
  }, []);

  return (
    <main className="terms-page">
      <header className="terms-header">
        <div className="terms-brand">
          <img src={logoNovi} alt="Novicompu" className="terms-logo-novi" />
          <span aria-hidden="true">+</span>
          <img src={logoEnv} alt="ENV" className="terms-logo-env" />
        </div>
        <Link to="/" className="terms-back">← Volver al formulario</Link>
      </header>
      <article className="terms-document">
        {error && <p className="terms-error" role="alert">{error}</p>}
        {!content && !error && <p className="terms-loading">Cargando documento…</p>}
        {content.split(/\r?\n/).map(renderLine)}
      </article>
      <footer className="terms-footer">Novicompu · Campaña aniversario 2026</footer>
    </main>
  );
}
